import React from 'react';
import PropTypes from 'prop-types';

/** MISCELLANIOUS */
import ThemeContext from '@thesoutherncross-uk/cassiopeia/dist/context/theme';
/** COMPONENTS */
import { PageRoot } from './styled';

/** PROP-TYPES */
const propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  primary: PropTypes.bool,
  centered: PropTypes.bool,
};

const defaultProps = { primary: false, centered: false };

/**
 * Page Component
 *
 * @param {*} { children, primary }
 * @returns
 */
const Page = ({ children, primary, centered, ...otherProps }) => {
  const theme = React.useContext(ThemeContext);
  return (
    <PageRoot
      {...otherProps}
      theme={theme}
      primary={primary}
      centered={centered}
    >
      {children}
    </PageRoot>
  );
};

/** PROP-TYPE ASSIGNMENT */
Page.propTypes = propTypes;
Page.defaultProps = defaultProps;

export default Page;
